export default __webpack_public_path__ + "fed1285aa7db1bcab072db32d9b00f19.png";